import {MediaCardType} from 'common/report/dashboards/types';
import {UserMediaType} from 'common/util/user-media-upload';

/*
  Dashboards MediaCardType needs to stay in sync with Dashboards API server (the values get saved in AppDB).
  UserMediaType is more general-purpose.
*/
export const UserMediaToDashboardMediaMap = {
  [UserMediaType.Image]: MediaCardType.Image,
  [UserMediaType.Video]: MediaCardType.Video,
  [UserMediaType.EmbeddedImage]: MediaCardType.EmbeddedImage,
  [UserMediaType.EmbeddedVideo]: MediaCardType.EmbeddedVideo,
};
